import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/ui/button';
import { Typography } from 'src/components/ui/typography';
import { useTrialBadge } from 'src/layouts/SidebarV2/hooks';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { IconAction } from 'src/layouts/SidebarV2/primitives';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const TrialBadge = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const { isOwner, expiryLabel, onUpgradeClick } = useTrialBadge();

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="tw:flex tw:w-full tw:flex-col tw:gap-m tw:rounded-2xl tw:py-m"
      style={{
        backgroundImage:
          'linear-gradient(198deg, #D2DAF7 9.5%, #E9E9F5 39.5%, #CFF3E1 70.48%, #C2F3DC 99.62%)'
      }}
    >
      <div className="tw:flex tw:items-center tw:gap-2xs tw:px-m">
        <Typography
          variant="b3"
          colorClass="tw:text-text-primary"
          className="tw:whitespace-nowrap"
        >
          {t(T.trialEndingOn)}
        </Typography>
        <Typography
          variant="h6"
          colorClass="tw:text-text-primary"
          className="tw:whitespace-nowrap"
        >
          {expiryLabel}
        </Typography>
        <IconAction
          icon={sidebarIcons.close}
          label="Dismiss"
          iconSize={16}
          colorClass="tw:text-text-primary"
          className="tw:ml-auto"
          onClick={() => setIsVisible(false)}
        />
      </div>
      <div className="tw:px-m">
        {isOwner ? (
          <Button
            hierarchy="primary"
            size="small"
            text={t(T.upgradeToPro)}
            onClick={onUpgradeClick}
            className="tw:w-full"
          />
        ) : (
          <Typography
            variant="b3"
            align="left"
            colorClass="tw:text-text-secondary"
            className="tw:w-full"
          >
            {t(T.upgradeRestrictedInfo)}
          </Typography>
        )}
      </div>
    </div>
  );
};

export { TrialBadge };
